import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-recommendations-form',
  templateUrl: './seo-off-page-recommendations-form.component.html',
  styleUrls: ['./seo-off-page-recommendations-form.component.css'],
})
export class SeoOffPageRecommendationsFormComponent {
  url: string = 'seoOffpageRecommendations';
  id!: string;
  form!: FormGroup;
  isViewOnly: boolean = false;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  landingTypes = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
  ];

  recommendationTypes = [
    { value: 'keyword_opportunity', label: 'Keyword Opportunity' },
    { value: 'backlink_gap', label: 'Backlink Gap' },
    { value: 'local_citation_gap', label: 'Local Citation Gap' },
    { value: 'anchor_mix', label: 'Anchor Mix' },
    { value: 'competitor_gap', label: 'Competitor Gap' },
    { value: 'authority_gap', label: 'Authority Gap' },
  ];

  priorities = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'critical', label: 'Critical' },
  ];

  statuses = [
    { value: 'new', label: 'New' },
    { value: 'approved', label: 'Approved' },
    { value: 'converted_to_campaign', label: 'Converted to Campaign' },
    { value: 'discarded', label: 'Discarded' },
    { value: 'done', label: 'Done' },
  ];

  sources = [
    { value: 'make_ai', label: 'Make AI' },
    { value: 'backend_rules', label: 'Backend Rules' },
    { value: 'manual', label: 'Manual' },
  ];

  suggestedKeywordsOptions: {
    shortTerm: string[];
    mediumTerm: string[];
    longTerm: string[];
  } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  suggestedAnchorsOptions: {
    shortTerm: string[];
    mediumTerm: string[];
    longTerm: string[];
  } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  targetAnchorsOptions: {
    shortTerm: string[];
    mediumTerm: string[];
    longTerm: string[];
  } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  targetLocationsOptions: {
    shortTerm: string[];
    mediumTerm: string[];
    longTerm: string[];
  } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  suggestedProspectTypesOptions: {
    shortTerm: string[];
    mediumTerm: string[];
    longTerm: string[];
  } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  suggestedDomainsOptions: {
    shortTerm: string[];
    mediumTerm: string[];
    longTerm: string[];
  } = { shortTerm: [], mediumTerm: [], longTerm: [] };

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });

    this.isViewOnly = this.router.url.includes('/view/');
    if (this.isViewOnly) {
      //this.form.disable();
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      targetKeyword: ['', [Validators.required]],
      city: [''],
      service: [''],
      industry: [''],
      targetUrl: ['', [Validators.required]],
      landingType: ['', [Validators.required]],
      recommendationType: ['', [Validators.required]],
      diagnosis: ['', [Validators.required]],
      recommendation: ['', [Validators.required]],
      proposedChanges: [''],
      priority: ['medium'],
      status: ['new'],
      source: ['manual'],
      suggestedKeywords: this.fb.group({
        shortTerm: [[]],
        mediumTerm: [[]],
        longTerm: [[]],
      }),
      suggestedAnchors: this.fb.group({
        shortTerm: [[]],
        mediumTerm: [[]],
        longTerm: [[]],
      }),
      targetAnchors: this.fb.group({
        shortTerm: [[]],
        mediumTerm: [[]],
        longTerm: [[]],
      }),
      targetLocations: this.fb.group({
        shortTerm: [[]],
        mediumTerm: [[]],
        longTerm: [[]],
      }),
      suggestedProspectTypes: this.fb.group({
        shortTerm: [[]],
        mediumTerm: [[]],
        longTerm: [[]],
      }),
      suggestedDomains: this.fb.group({
        shortTerm: [[]],
        mediumTerm: [[]],
        longTerm: [[]],
      }),
    });
  }

  toggleCheckbox(group: string, term: string, value: string, event: any) {
    const isChecked = event.target.checked;
    const arrayControl = this.form.get(`${group}.${term}`);
    if (!arrayControl) return;

    let currentValues = arrayControl.value || [];
    if (isChecked) {
      if (!currentValues.includes(value)) currentValues.push(value);
    } else {
      currentValues = currentValues.filter((v: string) => v !== value);
    }
    arrayControl.setValue(currentValues);
  }

  isChecked(group: string, term: string, value: string): boolean {
    const arrayControl = this.form.get(`${group}.${term}`);
    if (!arrayControl) return false;
    return (arrayControl.value || []).includes(value);
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      const data = response.data;
      console.log('data', data);
      this.form.patchValue({
        targetKeyword: data.targetKeyword,
        city: data.city,
        service: data.service,
        industry: data.industry,
        targetUrl: data.targetUrl,
        landingType: data.landingType,
        recommendationType: data.recommendationType,
        diagnosis: data.diagnosis,
        recommendation: data.recommendation,
        proposedChanges: data.proposedChanges,
        priority: data.priority,
        status: data.status,
        source: data.source,
        suggestedKeywords: {
          shortTerm: data.suggestedKeywords?.shortTerm || [],
          mediumTerm: data.suggestedKeywords?.mediumTerm || [],
          longTerm: data.suggestedKeywords?.longTerm || [],
        },
        suggestedAnchors: {
          shortTerm: data.suggestedAnchors?.shortTerm || [],
          mediumTerm: data.suggestedAnchors?.mediumTerm || [],
          longTerm: data.suggestedAnchors?.longTerm || [],
        },
        targetAnchors: {
          shortTerm: data.targetAnchors?.shortTerm || [],
          mediumTerm: data.targetAnchors?.mediumTerm || [],
          longTerm: data.targetAnchors?.longTerm || [],
        },
        targetLocations: {
          shortTerm: data.targetLocations?.shortTerm || [],
          mediumTerm: data.targetLocations?.mediumTerm || [],
          longTerm: data.targetLocations?.longTerm || [],
        },
        suggestedProspectTypes: {
          shortTerm: data.suggestedProspectTypes?.shortTerm || [],
          mediumTerm: data.suggestedProspectTypes?.mediumTerm || [],
          longTerm: data.suggestedProspectTypes?.longTerm || [],
        },
        suggestedDomains: {
          shortTerm: data.suggestedDomains?.shortTerm || [],
          mediumTerm: data.suggestedDomains?.mediumTerm || [],
          longTerm: data.suggestedDomains?.longTerm || [],
        },
      });

      this.suggestedKeywordsOptions = {
        shortTerm: data.suggestedKeywords?.shortTerm || [],
        mediumTerm: data.suggestedKeywords?.mediumTerm || [],
        longTerm: data.suggestedKeywords?.longTerm || [],
      };

      this.suggestedAnchorsOptions = {
        shortTerm: data.suggestedAnchors?.shortTerm || [],
        mediumTerm: data.suggestedAnchors?.mediumTerm || [],
        longTerm: data.suggestedAnchors?.longTerm || [],
      };

      this.targetAnchorsOptions = {
        shortTerm: data.targetAnchors?.shortTerm || [],
        mediumTerm: data.targetAnchors?.mediumTerm || [],
        longTerm: data.targetAnchors?.longTerm || [],
      };

      this.targetLocationsOptions = {
        shortTerm: data.targetLocations?.shortTerm || [],
        mediumTerm: data.targetLocations?.mediumTerm || [],
        longTerm: data.targetLocations?.longTerm || [],
      };

      this.suggestedProspectTypesOptions = {
        shortTerm: data.suggestedProspectTypes?.shortTerm || [],
        mediumTerm: data.suggestedProspectTypes?.mediumTerm || [],
        longTerm: data.suggestedProspectTypes?.longTerm || [],
      };

      this.suggestedDomainsOptions = {
        shortTerm: data.suggestedDomains?.shortTerm || [],
        mediumTerm: data.suggestedDomains?.mediumTerm || [],
        longTerm: data.suggestedDomains?.longTerm || [],
      };

      // if (this.isViewOnly) {
      //   this.form.disable();
      // }
    });
  }

  goBack(): void {
    this.router.navigateByUrl('marketing/seo/offPageRecommendations');
  }
}
